<template>
  <DpaNewsBanner
    class="flex flex-wrap items-center justify-center gap-4"
    appearance="accent-green">
    <div class="whitespace-nowrap">
      {{ t("generic.morningBriefing") }} {{ t("dates.from") }} {{ today }}
    </div>
    <a
      class="flex items-center gap-2 rounded-full border px-2 py-0.75 whitespace-nowrap"
      target="_blank"
      :href="url">
      <UiIcon size="xs" name="external-link" />
      <span class="text-xs/5">
        {{ t("generic.goToMorningBriefing") }}
      </span>
    </a>
  </DpaNewsBanner>
</template>

<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { format } from "date-fns";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import DpaNewsBanner from "@/components/shared/DpaNewsBanner/DpaNewsBanner.vue";

const { t } = useI18n();

defineProps<{
  url: string;
}>();

const today = ref(format(new Date(), "dd.MM.yyyy"));
</script>
